import React from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import {Theme, WithStyles, withStyles} from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  // @ts-ignore
  root: theme.buttonTypes != null ? theme.buttonTypes.remove : {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});

interface RemoveButtonProps extends WithStyles<typeof styles>, ButtonProps {
}

const RemoveButton = (props: RemoveButtonProps) => {
  const { classes: { root }, children, ...others } = props;
  return (
    <Button className={root} {...others}>
      {children}
    </Button>
  );
};

export default withStyles(styles)(RemoveButton);
